import { useQueryClient } from 'react-query';
import { LayerOperationsContext } from '../../../../components/compositionLayersTable/LayerOperationsContext';
import CompositionLayersTable from '../../../../components/compositionLayersTable/CompositionLayersTable';
import {
  useGetTemplateLayers,
  useGetTemplateLayerFunctions,
  useCreateTemplateLayer,
  useUpdateTemplateLayer,
  useDeleteTemplateLayer,
} from '../hooks/api';

type TemplateCompositionLayersTableProps = {
  templateId: string;
};

const TemplateCompositionLayersTable = ({ templateId }: TemplateCompositionLayersTableProps) => {
  const queryClient = useQueryClient();

  const { data: layers = [], isLoading, error } = useGetTemplateLayers(templateId);
  const { data: layerFunctions = [], isLoading: isLoadingFunctions } =
    useGetTemplateLayerFunctions();
  const { mutate: createLayer, isLoading: isCreating } = useCreateTemplateLayer();
  const {
    mutate: updateLayer,
    mutateAsync: updateLayerAsync,
    isLoading: isUpdating,
  } = useUpdateTemplateLayer();
  const { mutate: deleteLayer, isLoading: isDeleting } = useDeleteTemplateLayer();

  const handleSuccess = () => {
    queryClient.invalidateQueries(['template-layers', templateId]);
  };

  return (
    <LayerOperationsContext.Provider
      value={{
        entityId: templateId,
        layers,
        isLoading,
        error,
        createLayer,
        updateLayer,
        updateLayerAsync,
        deleteLayer,
        isCreating,
        isUpdating,
        isDeleting,
        layerFunctions,
        isLoadingFunctions,
        onSuccess: handleSuccess,
      }}
    >
      <CompositionLayersTable />
    </LayerOperationsContext.Provider>
  );
};

export default TemplateCompositionLayersTable;
